import Image, { StaticImageData } from 'next/image';
import { FC } from 'react';

type TSocialButtonProps = {
  img: StaticImageData;
  name: string;
  onClick: () => void;
};

const SocialButton: FC<TSocialButtonProps> = ({ img, name, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex justify-center gap-[10px] border border-clr-0a py-4 text-base text-clr-0a dark:border-clr-2e dark:text-white"
    >
      <Image src={img} alt="img" width={24} height={24} />
      <h1 className="dark:text-white">{name}</h1>
    </button>
  );
};

export default SocialButton;
